import { Duration } from 'luxon';

export const roundTwo = (num: number) => Math.round(num * 100) / 100;

export const getPercentComparedToAverage = (
  agentTotal: number,
  average: number
) => {
  if (average < 1) {
    average = 0;
  }
  if (average === 0) {
    if (agentTotal > 0) {
      return agentTotal * 100;
    } else {
      return 0;
    }
  }
  const averagePercent = roundTwo(agentTotal) / roundTwo(average);
  return roundTwo(averagePercent * 100);
};

export const secondsToHHMMSS = (seconds = 0) => {
  return Duration.fromMillis(seconds * 1000)
    .shiftTo('hours', 'minutes', 'seconds')
    .toFormat('hh:mm:ss');
};
